export default __webpack_public_path__ + "static/applozic-c82f4c84b6347d1557a9295dab7542c6.png";